import React from "react";
import { Drawer, Typography, Descriptions, Row, Col, Image } from "antd";
import { DescItem } from "../../utils/utils";
import { formatRecordDetails } from "../../utils/formatRecordDetails";

export const DetailFailsModal = ({ openDetails, setOpenDetails }) => {
  const repairDetails = formatRecordDetails(openDetails?.record?.repair_record);
  const failDetails = formatRecordDetails(openDetails?.record?.fail_record);

  return (
    <Drawer
      open={openDetails?.open}
      onCancel={() => {
        setOpenDetails({ open: false });
      }}
      onClose={() => {
        setOpenDetails({ open: false });
      }}
      footer={null}
      title={
        <Typography.Title style={{ margin: 0 }} level={3}>
          Детали жалобы
        </Typography.Title>
      }
      width={530}
      maskClosable={true}
    >
      <Descriptions
        bordered
        column={1}
        labelStyle={{ color: "black", width: 200 }}
        style={{ marginTop: "20px" }}
      >
        {DescItem(
          "Тип жалобы",
          openDetails?.record?.fail_type?.length > 0
            ? openDetails?.record?.fail_type?.map((item) => {
                return (
                  <Row key={item?.id}>
                    <Col>{item?.name}</Col>
                  </Row>
                );
              })
            : "Нет данных"
        )}
        {DescItem("Жалоба на запись", failDetails)}
        {DescItem("Услуга", openDetails?.record?.service?.y_title)}
        {DescItem(
          "Фото от клиента",
          openDetails?.record?.photos?.length > 0 ? (
            <Row gutter={5}>
              {openDetails.record.photos.map((item) => (
                <>
                  <Col key={item?.id}>
                    <Image width={72} height={72} src={item?.photo} />
                  </Col>
                </>
              ))}
            </Row>
          ) : (
            "Нет данных"
          )
        )}
        {DescItem("Комментарий", openDetails?.record?.comment)}
        {DescItem(
          "Вычет из ЗП мастера",
          `${openDetails?.record?.repair_cost?.toLocaleString("ru-RU")} р.`
        )}
        {DescItem(
          "Сумма скидки",
          `${openDetails?.record?.loyal_cost?.toLocaleString("ru-RU") || 0} р.`
        )}
        {DescItem("Запись переделки", repairDetails)}
      </Descriptions>
    </Drawer>
  );
};
